import parseLinkHeader from "parse-link-header";
import invariant from "invariant";

/**
 * Parse the data received from the Response's Headers
 * @param  {Headers} headers - The Response's Headers
 * @return {Object} - The data contain in the Response's Headers
 */
export const parseReceivedHeaders = (headers) => {
	const data = {};

	// Retrieve the total of the resource
	if (headers.get("total-count") && !isNaN(headers.get("total-count"))) {
		data.total = +headers.get("total-count");
	} else if (headers.get("x-total") && !isNaN(headers.get("x-total"))) {
		data.total = +headers.get("x-total");
	}

	// Parse the link to retrieve the "prev" and "next" urls for resources.
	if (headers.get("link")) {
		Object.values(parseLinkHeader(headers.get("link"))).reduce((value, { rel, url }) => {
			value[rel] = url;
			return value;
		}, data);
	}

	return data;
};

export class APIError extends Error {
	constructor(message, response, value) {
		super(message);
		invariant(response, 'response is empty');
		this.response = response;
		this.value = value;
	}

	get status() {
		return this.response.status;
	}
}

export class BaseModel {
	constructor(values) {
		Object.assign(this, values);
	}

	getKey() {
		return this.id;
	}
}

export class BaseUnlistableModel {
	constructor(data, id) {
		this.id = id;
		this.data = data;
	}

	getKey() {
		return this.id;
	}
}

export class BaseSingleModel {
	constructor(values) {
		Object.assign(this, values);
	}

	getKey() {
		return '';
	}
}

export class Conflict {
	constructor(values) {
		Object.assign(this, values);
	}
}
